import { render, staticRenderFns } from "./inspection-report-sent.vue?vue&type=template&id=7b4ac5da"
import script from "./inspection-report-sent.vue?vue&type=script&lang=js"
export * from "./inspection-report-sent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports